export default __webpack_public_path__ + "static/media/s001.3a7d002c.png";